import { render } from "./ModalAssetUpload.vue?vue&type=template&id=5235d4f6&scoped=true"
import script from "./ModalAssetUpload.vue?vue&type=script&lang=js"
export * from "./ModalAssetUpload.vue?vue&type=script&lang=js"

import "./ModalAssetUpload.vue?vue&type=style&index=0&id=5235d4f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5235d4f6"]])

export default __exports__